import {Injectable, Injector} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {AuthService} from './auth/auth.service';

/**
 * Service providing predicting maintenance values
 */
@Injectable({
  providedIn: 'root'
})
export class PmService {

  private cBrokerEndpoint = null;

  constructor(private injector: Injector,
              private httpClient: HttpClient,
              private authService: AuthService) {

    this.cBrokerEndpoint = `${environment.server.contextBrokerApi}/realms/${this.authService.getRealmId()}/ngsi-ld/v1`;
  }

  /**
   * Get predictive maintenance values
   */
  getPMValues(startTime: any, endTime: any, limit: any,  cBrokerEndpoint: string = null) {
    const entityType = 'PredictiveMaintenanceOutput';

    let urlParameter = '?type=' + encodeURIComponent(entityType);
    urlParameter += '&timerel=between&time=' + encodeURIComponent(startTime);
    urlParameter += '&endTime=' + encodeURIComponent(endTime);
    urlParameter += '&limit=' + encodeURIComponent(limit);



    const url: string = cBrokerEndpoint ? `${cBrokerEndpoint}/temporal/entities${urlParameter}` : `${this.cBrokerEndpoint}/temporal/entities${urlParameter}`;
    return this.httpClient.get(url);
  }

}
